import { SetupProviderFormState } from '@Forms/providers/SetupProviderFormContext';
import { UpdateRequest } from '@contracts/api/dto/common/UpdateRequest';
import { ProviderItemDto } from '@contracts/api/dto/providers/ProviderDto';

export const useSetupProviderUseCaseMapper = (provider: ProviderItemDto) => {
  return {
    toFormState: async (providerId: string): Promise<SetupProviderFormState | undefined> => {
      return {
        name: provider?.name,
        apiUrl: provider?.apiUrl,
        syncRoundEnd: provider?.syncRoundEnd,
        status: provider?.status,
        retryScheduledSendCredit: provider?.retryScheduledSendCredit,
        retryConfigId: provider?.retryConfigId || undefined,
        refundOnCreditFail: provider?.refundOnCreditFail,
        filterExternalProviderBets: provider?.filterExternalProviderBets,
        isInternal: provider?.isInternal,
        configId: provider?.configId || undefined,
        creditOnDisconnect: provider?.creditOnDisconnect,
        games: provider?.games,
        integrationType: provider?.integrationType,
      };
    },
    toDto: (formState: SetupProviderFormState): UpdateRequest<SetupProviderFormState> => {
      // @ts-ignore
      return {
        body: {
          name: formState.name,
          apiUrl: formState.apiUrl,
          syncRoundEnd: formState.syncRoundEnd,
          status: formState.status,
          retryScheduledSendCredit: formState.retryScheduledSendCredit,
          retryConfigId: formState.retryConfigId || undefined,
          refundOnCreditFail: formState.refundOnCreditFail,
          filterExternalProviderBets: formState.filterExternalProviderBets,
          isInternal: formState.isInternal,
          configId: formState.configId || undefined,
          creditOnDisconnect: formState.creditOnDisconnect,
          games: formState.games,
          integrationType: formState.integrationType,
        },
      };
    },
  };
};
